/**
 * @generated SignedSource<<572313e67b80a6993d6c1a143d5a496c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LemonLinkGetMutation$variables = {
  returnPath?: string | null;
  storeId?: string | null;
  type: string;
};
export type LemonLinkGetMutation$data = {
  readonly getLemonLink: {
    readonly link: string;
  } | null;
};
export type LemonLinkGetMutation = {
  response: LemonLinkGetMutation$data;
  variables: LemonLinkGetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "returnPath"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "returnPath",
        "variableName": "returnPath"
      },
      {
        "kind": "Variable",
        "name": "storeId",
        "variableName": "storeId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "LemonLink",
    "kind": "LinkedField",
    "name": "getLemonLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "link",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LemonLinkGetMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LemonLinkGetMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1d6f519ca47f0ae67e29d82871c63bec",
    "id": null,
    "metadata": {},
    "name": "LemonLinkGetMutation",
    "operationKind": "mutation",
    "text": "mutation LemonLinkGetMutation(\n  $type: String!\n  $storeId: String\n  $returnPath: String\n) {\n  getLemonLink(type: $type, storeId: $storeId, returnPath: $returnPath) {\n    link\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f77b9eff1d7cbbd5cf44dd11470adf2";

export default node;
